import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const unissueTransferOrderRequest: RequestExample = {
    title: {
        verb: 'POST',
        endpointUrl: '/api/transfer-orders/:id/unissue',
    },
    curl:
        `curl --location \\
--request POST '<YOUR SERVER>/api/transfer-orders/:id/unissue' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const unissueTransferOrderResponse: Json = {
    title: 'RESPONSE',
    json: {
        'id': 23,
        'number': '25',
        'status': 'Entered',
        'type': 'Ship',
        'fromLocationGroup': {
            'id': 1,
            'name': 'Main'
        },
        'toLocationGroup': {
            'id': 2,
            'name': 'NY'
        },
        'carrier': {
            'id': 4,
            'name': 'Fedex',
            'service': {
                'id': 8,
                'name': 'Ground'
            }
        },
        'shipFromAddress': {
            'name': 'Main Warehouse',
            'street': '100 Main St',
            'city': 'Salt Lake City',
            'state': 'UT',
            'postalCode': '84101',
            'country': 'UNITED STATES'
        },
        'shipToAddress': {
            'name': 'East Warehouse',
            'street': '200 East Blvd',
            'city': 'Denver',
            'state': 'CO',
            'postalCode': '80201',
            'country': 'UNITED STATES'
        },
        'note': 'Urgent transfer for Q2 rebalancing',
        'ownerIsFrom': true,
        'revisionNumber': 2,
        'lastModified': {
            'username': 'admin',
            'dateLastModified': '2026-06-25T16:31:47.000+00:00'
        },
        'dateCreated': '2026-05-26T15:45:27.000+00:00',
        'dateScheduled': '2025-12-29T01:44:45.000+00:00',
        'toItems': [
            {
                'id': 91,
                'part': {
                    'id': 28,
                    'name': 'B201',
                    'description': 'Premium Brake Cables'
                },
                'type': {
                    'id': 10,
                    'name': 'Send'
                },
                'status': 'Entered',
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'lineNumber': 1,
                'note': 'Handle with care',
                'quantity': '10',
                'quantityFulfilled': '3',
                'quantityPicked': '3',
                'unitCost': '25.50',
                'dateScheduled': '2026-05-26T15:45:27.000+00:00'
            }
        ],
        'customFields': [
            {
                'id': 22,
                'name': 'Department',
                'value': 'Logistics',
                'type': 'Text'
            }
        ]
    },
};

const data: RequestDefinitionData = {
    id: 'unissue-transfer-order',
    title: 'Unissue a transfer order',
    description: 'Transitions a transfer order from Issued status back to Entered. ' +
        'Unissuing removes associated picks and receipts. ' +
        'Only the owner location group can unissue a transfer order. ' +
        'Returns 404 if the transfer order is not found.',
    endpoint: {
        verb: 'POST',
        path: '/transfer-orders/:id/unissue',
        tooltip: 'Unissue a transfer order',
    },
    attributes: [],
    requestObject: unissueTransferOrderRequest,
    responseObject: unissueTransferOrderResponse,
};

export default data;
